import { useTheme } from '@mui/material/styles';
import { Box, ListItemIcon } from '@mui/material';
import { useSelector } from 'store';
import { NavItemType } from 'types/menu';

interface Props {
  item: NavItemType;
}

const NavInput = ({ item }: Props) => {
  const theme = useTheme();
  const menu = useSelector((state) => state.menu);
  const { drawerOpen } = menu;
  const Icon = item.icon;
  const itemIcon = Icon ? <Icon style={{ fontSize: drawerOpen ? '1rem' : '1.25rem' }} /> : false;  

  return (
    <>
    {itemIcon && !drawerOpen && (
      <Box sx={{ ml: { xs: 2, md: 1.5 } }}>
      <ListItemIcon
            sx={{
              minWidth: 28,
              ...(!drawerOpen && {
                borderRadius: 1.5,
                width: 36,
                height: 36,
                alignItems: 'center',
                justifyContent: 'center',
                '&:hover': {
                  bgcolor: theme.palette.mode === 'dark' ? 'secondary.light' : 'secondary.lighter'
                }
              })
            }}
          >
            {itemIcon}
          </ListItemIcon>
          </Box>
        )}
    </>
  );
};

export default NavInput;
